import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "futures_bot_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

// Attach Bearer token on every request
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Redirect to /login on 401
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export const endpoints = {
  login: (password) => api.post("/auth/login", { password }),
  me: () => api.get("/auth/me"),
  settings: () => api.get("/settings"),
  aiHealth: (force = false) => api.get(`/ai/health${force ? "?force=true" : ""}`),
  updateSettings: (data) => api.put("/settings", data),
  botStatus: () => api.get("/bot/status"),
  botToggle: () => api.post("/bot/toggle"),
  symbols: (limit = 100) => api.get(`/symbols?limit=${limit}`),
  ticker: (symbol) => api.get(`/ticker/${symbol}`),
  klines: (symbol, interval = "15m", limit = 150) =>
    api.get(`/klines/${symbol}?interval=${interval}&limit=${limit}`),
  signals: (symbol, interval = "15m") =>
    api.get(`/signals/${symbol}?interval=${interval}`),
  portfolio: () => api.get("/portfolio"),
  positions: () => api.get("/positions"),
  history: (limit = 100) => api.get(`/positions/history?limit=${limit}`),
  aiModeStats: () => api.get("/stats/ai-mode"),
  confidenceStats: () => api.get("/stats/confidence"),
  closePosition: (id) => api.post(`/positions/${id}/close`),
  closeAllPositions: () => api.post("/positions/close-all"),
  telegramTest: (bot_token, chat_id) =>
    api.post("/telegram/test", { bot_token, chat_id }),
  dataSource: () => api.get("/data-source"),
  neurobro: (symbol) => api.get(`/neurobro/${symbol}`),
  scannerResults: () => api.get("/scanner/results"),
  scannerStatus: () => api.get("/scanner/status"),
  scannerScanAll: () => api.post("/scanner/scan-all"),
  binanceTest: (api_key, api_secret, testnet) =>
    api.post("/binance/test", { api_key, api_secret, testnet }),
  resetPortfolio: (initial_balance) =>
    api.post("/portfolio/reset", { initial_balance }),
  resetMetric: (metric) => api.post("/portfolio/reset-metric", { metric }),
};
